import type { PropsWithChildren } from 'react';
import type React from 'react';
import { useState } from 'react';

import type { IconName } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledCloseIcon, StyledContentContainer, StyledIcon, StyledInlineAlert } from './styles';

export type InlineAlertVariant = 'info';

interface Props {
  variant: InlineAlertVariant;
  margin?: string;
  isVisible?: boolean;
  onCloseClick?: () => void;
}

const variantToIcon: Record<InlineAlertVariant, IconName> = {
  info: 'info',
};

export const InlineAlert: React.FC<PropsWithChildren<Props>> = ({
  variant,
  children,
  margin,
  isVisible: isVisibleProp,
  onCloseClick,
}) => {
  const [isVisible, setIsVisible] = useState(isVisibleProp ?? true);

  const handleCloseClick = () => {
    setIsVisible(false);
    onCloseClick?.();
  };

  if (!isVisible) {
    return null;
  }

  return (
    <StyledInlineAlert variant={variant} margin={margin}>
      <StyledIcon iconName={variantToIcon[variant]} size="xs" />
      <StyledContentContainer>{children}</StyledContentContainer>
      <div onClick={handleCloseClick}>
        <StyledCloseIcon iconName="clear" size="xs" iconColor={colorsPalettes.carbon[400]} />
      </div>
    </StyledInlineAlert>
  );
};
